import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import spacex from "../../Assets/Projects/Spacex.png";
import emotion from "../../Assets/Projects/emotion.png";
import shopify from "../../Assets/Projects/shopify.png";
import imageSearch from "../../Assets/Projects/imageSearch.png";
import suicide from "../../Assets/Projects/suicide.png";
import urlShortener from "../../Assets/Projects/urlShortener.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={imageSearch}
              isBlog={false}
              title="IMAGE  SEARCH  ENGINE"
              description=" Developed and deployed a functional Google Images Clone using Javascript,ReactJS,HTML,CSS and API Integration that allows user to search desired image."
              ghLink="https://github.com/tanvi2807/img-search-engine"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={urlShortener}
              isBlog={false}
              title="URL  SHORTENER"
              description="Engineered and implemented a custom URL Shortener in C++ that maps old long URLS with new shortened URL improving link management and reducing link tracking errors."
              ghLink="https://github.com/tanvi2807/UrlShortner"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shopify}
              isBlog={false}
              title="SHOPPING WEBAPP"
              description="Developed a secure, feature-rich shopping application utilizing Node.js, Express.js, and MongoDB, incorporating robust user authentication and authorization functionalities."
              ghLink="https://github.com/tanvi2807/Shopping-App"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={spacex}
              isBlog={false}
              title="SPACEX"
              description="Spacex is a webapp that store all the records about the launches and it was built using Reactjs in which the status of the mission is conditionally rendered."
              ghLink="https://github.com/tanvi2807/interview-for-tanvi2807"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col> */}
{/* 
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
